exports.status = true //true为正式，false为测试